import React from 'react'
import { Button } from 'antd'
import classes from './styles.module.scss'
const ErrorPrompt = ({ onTryAgain }) => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <p className={classes.title}>Oops! We couldn't load your QR</p>
    <p className={classes.text}>Something went wrong while loading your QR.</p>
    <p className={classes.twotext}>Please try again.</p>
    <Button type='primary' style={{ width: '100%', height:'48px', fontSize:'16px' }} onClick={onTryAgain}>
            Try again
    </Button>
  </div>
)

export default ErrorPrompt
